import React, { createContext } from 'react';

import type { PanelSystemState } from './types';

/**
 * Context for accessing the panel system state.
 * Consumers of this context will re-render when state changes.
 * @internal
 */
export const StateContext: React.Context<PanelSystemState | null> =
	createContext<PanelSystemState | null>(null);
